"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _sizes = _interopRequireDefault(require("../../scss/variables/_sizes.scss"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _Slider = _interopRequireDefault(require("./components/Slider"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var UTCarousel = function UTCarousel(_ref) {
  var arrow = _ref.arrow,
      legend = _ref.legend,
      imgArray = _ref.imgArray,
      borderSize = _ref.borderSize,
      autoPlay = _ref.autoPlay,
      _ref$autoPlayDelay = _ref.autoPlayDelay,
      autoPlayDelay = _ref$autoPlayDelay === void 0 ? 2000 : _ref$autoPlayDelay,
      classes = _ref.classes,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? _sizes["default"].defaultCarrouselHeight : _ref$height,
      activeEvents = _ref.activeEvents,
      className = _ref.className;
  return _react["default"].createElement(_Slider["default"], {
    arrow: arrow,
    legend: legend,
    slides: imgArray,
    withBorder: borderSize,
    autoPlay: autoPlay,
    autoPlayDelay: autoPlayDelay,
    classes: classes,
    height: height,
    activeEvents: activeEvents,
    className: className
  });
};

UTCarousel.propTypes = {
  arrow: (0, _propTypes.shape)({
    position: _propTypes.string,
    arrowCustomLeft: _propTypes.node,
    arrowCustomRight: _propTypes.node,
    callbackLeft: _propTypes.func,
    callbackRight: _propTypes.func
  }),
  legend: (0, _propTypes.shape)({
    position: _propTypes.string,
    legendCustom: _propTypes.node
  }),
  imgArray: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    imgSrc: _propTypes.string
  })),
  borderSize: _propTypes.number,
  autoPlay: _propTypes.bool,
  autoPlayDelay: _propTypes.number,
  height: _propTypes.string,
  activeEvents: _propTypes.bool,
  className: _propTypes.string,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(UTCarousel);

exports["default"] = _default;